import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTA({ label, to, tone = "dark" }) {
  const styles =
    tone === "dark"
      ? "text-[hsl(var(--ink))] border-[hsl(var(--ink))] hover:bg-[hsl(var(--ink))] hover:text-[hsl(var(--bg))]"
      : "text-[hsl(var(--bg))] border-[hsl(var(--bg))] hover:bg-[hsl(var(--bg))] hover:text-[hsl(var(--ink))]";
  return (
    <Link
      to={to}
      className={`inline-flex items-center gap-3 border rounded-none px-6 py-3 text-[11px] tracking-[0.35em] uppercase transition-colors duration-500 ${styles}`}
    >
      {label}
      <ArrowRight size={14} />
    </Link>
  );
}
